export default "/images/JanVanĕček.jpg?ca9b3071b7e5a5f69a1b56db12870a16";